import { Button } from "antd"
import { MessageOutlined, PlusCircleOutlined } from "@ant-design/icons"
import { useContext } from "react"
import {
  CommentsContext
} from "../../../../../contexts/admin/submissions/review/comments/context"
import PropTypes from "prop-types"


CommentButton.propTypes = {
  entity: PropTypes.string,
  entityId: PropTypes.string,
  name: PropTypes.string,
  section: PropTypes.string,
  small: PropTypes.bool,
  large: PropTypes.bool,
  largeButtonText: PropTypes.string
}

export function CommentButton({ entity, entityId, name, section, small, large, largeButtonText, isSpecSheet = false, idSpecSheet = "", isBeneficiaryPage= false, countComments, isExpenseReconciliation=false }) {
  const commentsContext = useContext(CommentsContext)

  if (!commentsContext || !entityId) {
    return null
  }

  const field = { name, section, entity, entityId }

  const { loading, readOnly, openCommentsModal, getCommentsByField, getCommentsByFieldInspecSheet, getCommentsByFieldInspecSheetByBeneficiary } = commentsContext

  let comments = 0
  let allComments = []
  let allCommentsReviewed = false


  if (isSpecSheet) {
    const rawComments = !isBeneficiaryPage
      ? getCommentsByFieldInspecSheet(field, idSpecSheet)
      : getCommentsByFieldInspecSheetByBeneficiary(field, idSpecSheet)
  
    allComments = rawComments?.filter(comment => !comment.parentCommentId) || []
  
    comments = allComments.length
    allCommentsReviewed = allComments.every(comment => comment.reviewed === true)
  
    if (countComments) {
      countComments(comments)
    }
  }
  else {
    allComments = getCommentsByField(field)
    const mainComments = allComments?.filter(comment => !comment.parentCommentId)
    
    comments = mainComments?.length || 0
  
    allCommentsReviewed = mainComments?.every(comment => comment.reviewed === true)

  }

  const onClick = () => {
    openCommentsModal(field)
  }

  if (loading) {
    return (
      <Button
        size="small"
        shape="round"
        loading={true}
        style={{ float: "right" }} />
    )
  }

  if (comments > 0 && !large){
    return (
      <Button
        size="small"
        shape="round"
        style={{
          float: "right",
          backgroundColor: allCommentsReviewed ? "#19af26" : "#d54650",
          color: "white"
        }}
        icon={<MessageOutlined />}
        onClick={!isSpecSheet ? onClick : () => { }}>
        {comments}
      </Button>
    )
  }

  if (isSpecSheet) {
    return (
      <Button
        size="small"
        shape="round"
        style={{
          float: "right",
          backgroundColor:  allCommentsReviewed ? "#19af26" : "#d54650",
          color: "white"
        }}
        icon={<MessageOutlined />}
        onClick={!isSpecSheet ? onClick : () => { }}>
        {comments}
      </Button>
    )
  }

  if (small) {
    return (
      <Button
        size="small"
        shape="round"
        onClick={!isSpecSheet ? onClick : () => { }}
        icon={<MessageOutlined />} />
    )
  }

  if (large) {
    return (
      <Button
        shape="round"
        icon={<MessageOutlined />}
        onClick={!isSpecSheet ? onClick : () => { }}
        style={{ backgroundColor: comments > 0 ?  allCommentsReviewed ? "#19af26" : "#d54650" : "initial" }}>
        {comments > 0 ? `(${comments}) ` : null}{largeButtonText}
      </Button>
    )
  }

  if(isExpenseReconciliation){
    return (
      <Button
        size="small"
        shape="round"
        style={{ backgroundColor: comments > 0 ?  allCommentsReviewed ? "#19af26" : "#d54650" : "initial" }}
        onClick={!isSpecSheet ? onClick : () => { }}
        icon={readOnly ? null : <MessageOutlined />}>
       {comments > 0 ? `(${comments}) ` : null}
      </Button>
    )
  }

  const buttonText = readOnly ? "Comentarios" : "Comentar"

  return (
    <Button
      size="small"
      shape="round"
      style={{ float: "right", background:"white"}}
      onClick={!isSpecSheet ? onClick : () => { }}
      icon={readOnly ? null : <PlusCircleOutlined/>}>
      {buttonText}
    </Button>
  )
}
